import { render, staticRenderFns } from "./GuessAnswer.vue?vue&type=template&id=35b3a08c"
import script from "./GuessAnswer.vue?vue&type=script&lang=js"
export * from "./GuessAnswer.vue?vue&type=script&lang=js"
import style0 from "./GuessAnswer.vue?vue&type=style&index=0&id=35b3a08c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports